
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring/create",
      function () {
        return require("private-next-pages/hiring/create/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiring/create"])
      });
    }
  